import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AppStateService} from '../../shared/app-state.service';
import {QccInfoResponse} from '../client-api.service';
import {ClientApiService} from '../client-api.service';

@Component({
  selector: 'positions-page-mock-header',
  templateUrl: './positions-page-mock-header.component.html',
  styleUrls: [
    '../../core/app-header/app-header.component.scss'
  ]
})
export class PositionsPageMockHeaderComponent implements OnInit {
  @Input() qccInfoResponse: QccInfoResponse;

  brand$ = this.AppState.brand$;
  locale$ = this.AppState.locale$;
  invoicingAllowed$ = new BehaviorSubject(false);
  useElectronicSignatures$ = new BehaviorSubject(true);
  timecardsOnly$ = new BehaviorSubject(false);

  minimal$ = this.AppState.minimal$;

  constructor(private AppState: AppStateService,
              private ClientApi: ClientApiService) {
  }

  ngOnInit(): void {
    if (this.qccInfoResponse) {
      this.AppState.locale$.next(this.qccInfoResponse.locale);
      this.AppState.brand$.next(<Brand>this.qccInfoResponse.locale);

      this.ClientApi.getQccReviewerAccountInfo(this.qccInfoResponse.orders[0].order).subscribe( user => {
        if (user.brand) {
          this.invoicingAllowed$.next(user.invoicingAllowed);
          this.useElectronicSignatures$.next(user.timeCardSigner);
          if (3 == user.accountTypeId) {
            this.timecardsOnly$.next(true);
          }
        }
      });
    }
  }
}
